import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    recipientAmount: "",
    recipientCurrency: "",
    recipientMemo: "",
    recipientInvoice: null,
    recipientOtherDocument: null,
    bankProvider: null,
    bankRecipient: {
        name: "",
        accountNumber: "",
        bankName: "",
        bankCode: "",
        swiftCode: "",
        beneficiaryId: "",
        transactionId: "",
    },
};

const bankTransferSlice = createSlice({
    name: "bankTransfer",
    initialState,
    reducers: {
        setBankAmount: (state, action) => {
            state.recipientAmount = action.payload;
        },
        setBankCurrency: (state, action) => {
            state.recipientCurrency = action.payload;
        },
        setBankMemo: (state, action) => {
            state.recipientMemo = action.payload;
        },
        setBankInvoice: (state, action) => {
            state.recipientInvoice = action.payload;
        },
        setBankOtherDocument: (state, action) => {
            state.recipientOtherDocument = action.payload;
        },
        setBankProvider: (state, action) => {
            state.bankProvider = action.payload;
        },
        setBankRecipient: (state, action) => {
            state.bankRecipient = {
                ...state.bankRecipient,
                ...action.payload,
            };
        },
        resetBankTransfer: () => initialState,
    },
});

export const {
    setBankAmount,
    setBankCurrency,
    setBankMemo,
    setBankInvoice,
    setBankOtherDocument,
    setBankProvider,
    setBankRecipient,
    resetBankTransfer,
} = bankTransferSlice.actions;

export default bankTransferSlice.reducer;
